
import * as actionTypes from '../actions/actionTypes';
import { getUsersMetricesData, getToolkitMetricsData, getChartMetricsData, getActionsMetricsData, getStoriesMetricsData } from '../../utils/fetchStaticData';

const initialState = {
    UsersAnalytics: [],
    ToolkitAnalytics: [],
    ChartAnalytics: [],
    ActionsAnalytics: [],
    StoriesAnalytics: [],
    UsersMetrics: [],
    ToolkitMetrics: [],
    ChartMetrics: [],
    ActionsMetrics: [],
    StoriesMetrics: []

};

export default function (state = initialState, action) {
    
    switch (action.type) {
        case actionTypes.STORE_USERS_ANALYTICS_DATA:
                return { ...state, UsersAnalytics: action.val };

        case actionTypes.STORE_TOOLKIT_ANALYTICS_DATA:
            return { ...state, ToolkitAnalytics: action.val };

        case actionTypes.STORE_CHART_ANALYTICS_DATA:
            return { ...state, ChartAnalytics: action.val };

        case actionTypes.STORE_ACTIONS_ANALYTICS_DATA:
            return { ...state, ActionsAnalytics: action.val };

        case actionTypes.STORE_STORIES_ANALYTICS_DATA:
            return { ...state, StoriesAnalytics: action.val };

        case actionTypes.FETCH_USERS_METRICES_LIST:
            return { ...state, UsersMetrics: getUsersMetricesData('UsersMetrics') };

        case actionTypes.FETCH_TOOLKIT_MATRICS_LIST:
            return { ...state, ToolkitMetrics: getToolkitMetricsData('ToolkitMetrics') };

        case actionTypes.FETCH_CHART_MATRICS_LIST:
            return { ...state, ChartMetrics: getChartMetricsData('ChartMetrics')}
            
        case actionTypes.FETCH_ACTIONS_METRICES_LIST:
            return { ...state, ActionsMetrics: getActionsMetricsData('ActionsMetrics')}
        
        case actionTypes.FETCH_STORIES_MATRICES_LIST:
            return { ...state, StoriesMetrics: getStoriesMetricsData('StoriesMetrics')}

        default:
            break;
    }
    return state;
}
